import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ReportGmailerrorredIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"report_gmailerrorred"} ref={ref}/>
});

ReportGmailerrorredIcon.displayName = "ReportGmailerrorredIcon";
